interface HeapIO {
    addUserProperties: (value: Record<string, string>) => void;
    track: (event: string, options?: Record<string, string>) => void;
}

export const useHeapIO = () => {
    // Resolves Heap at call time to handle late SDK loading and ad blocker scenarios
    const getHeapIO = (): HeapIO | undefined => {
        if ("heap" in window && window.heap && typeof (window.heap as HeapIO).addUserProperties === "function") {
            return window.heap as HeapIO;
        }
        return undefined;
    };

    const trackEvent = (event: string, options?: Record<string, string>) => {
        getHeapIO()?.track(event, options);
    };

    const addUserProperty = (value: Record<string, string>) => {
        getHeapIO()?.addUserProperties(value);
    };

    const addAuthenticatedProperty = () => {
        addUserProperty({ Authenticated: "true" });
    };

    const trackAssistantCompletion = () => {
        trackEvent("ai_assistant_completion");
    };

    return { trackAssistantCompletion, addAuthenticatedProperty };
};
